{
    "home.title": "Meine Läden",
    "home.store.openTasks": "Offene Aufgaben",
    "home.stores.title": "Zuhause",
    "home.noMobileAccess.title": "Dieses Konto hat keinen Zugriff auf die Badger Mobile-App.",
    "home.noMobileAccess.body": "Wenden Sie sich an Ihren Manager, um Zugriff anzufordern.",
    "home.noHomeStore.message": "Sie haben keinen Heimladen festgelegt. Bitte kontaktieren Sie Ihren Manager.",
    "home.myStores.title": "Meine Läden",
    "home.myStores.link": "Läden",
    "home.label.edit": "Meine Läden",

    "tasks.label": "Aufgaben",
    "tasks.store.allTasks": "Alle Aufgaben",
    "tasks.filters.allTaskTypes": "Alle Aufgabentypen",
    "tasks.filters.allResolutionTypes": "Alle Lösungstypen",
    "tasks.store.idLabel": "Laden-ID",
    "tasks.store.outOfStock": "Ausverkauft",
    "tasks.store.wrong": "Falsch",
    "tasks.store.price": "Preis",
    "tasks.store.salePrice": "Angebotspreis",
    "tasks.store.taskMap": "Aufgabenkarte",
    "tasks.allAisles": "Alle Gänge",
    "tasks.supress.message": "Diese Aufgabe wird für 7 Tage verschoben.",
    "tasks.list.completeTask": "Aufgabe abschließen",
    "tasks.list.flagTask": "Aufgabe markieren",
    "tasks.store": "Laden",
    "tasks.aisles": "Gänge",
    "tasks.complete.message": "Aufgabe erfolgreich abgeschlossen.",
    "tasks.error.message": "Beim Ausführen der Aufgabe ist ein Fehler aufgetreten.",
    "tasks.general.message": "Die Aufgabe konnte nicht abgeschlossen werden.",

    "profile.title": "Profil",
    "profile.name.label": "Name",
    "profile.email.label": "E-Mail",
    "profile.organization.label": "Organisation",
    "profile.homeStore.label": "Heimladen",
    "profile.role.label": "Rolle",
    "profile.roles.label": "Rollen",

    "general.label.today": "Heute",
    "general.label.search": "Suche",
    "general.label.comment": "Kommentar",
    "general.label.comments": "Kommentare",
    "general.label.resolved": "Gelöst",
    "general.label.new": "Neu",
    "general.label.edit": "Bearbeiten",
    "general.label.signOut": "Abmelden",
    "general.label.actionable": "Handlungsfähig",
    "general.action.save": "Speichern",
    "general.action.cancel": "Abbrechen",
    "general.action.close": "Schließen",
    "general.action.snooze": "Schlummern",
    "general.action.create": "Erstellen",
    "general.home.title": "Startseite",
    "general.tasks.title": "Aufgaben",
    "general.users.title": "Profil",
    "general.rfid.title": "RFID",
    "general.label.products": "Produkte",
    "general.action.prev": "Zur.",
    "general.action.next": "Weiter",
    "general.label.gtin": "GTIN",
    "general.label.all": "Alle",

    "sort.label.taskCount": "Aufgabenanzahl",
    "sort.label.aisleName": "Gangname",
    "sort.label.aisleLocation": "Gangstandort",
    "sort.label.shelfLocation": "Regalstandort",
    "sort.label.taskType": "Aufgabentyp",
    "sort.label.productName": "Produktname",
    "sort.label.sku": "SKU",
    "sort.label.recurrenceCount": "Wiederholungsanzahl",
    "sort.label.tagCount": "Anzahl der Tags",

    "task.type.price": "Preis",
    "task.type.salePrice": "Angebotspreis",
    "task.type.outOfStock": "Ausverkauft",
    "task.type.wrong": "Falscher Artikel",

    "task.resolution.autoResolved": "Automatisch gelöst",
    "task.resolution.completed": "Abgeschlossen",
    "task.resolution.flagged": "Markiert",
    "task.resolution.not a problem": "Kein Problem",
    "task.resolution.no stock found": "Kein Lagerbestand zum Auffüllen",

    "task.status.active": "Aktiv",
    "task.status.completed": "Gelöst",
    "task.status.suppressed": "Geschlummert",
    "task.status.expired": "Abgelaufen",

    "tasks.paths.label": "Gänge",

    "validation.error.required": "Dieses Feld ist erforderlich",
    "validation.error.minLength": "Die Mindestlänge beträgt {{length}} Zeichen",

    "user.label.email": "E-Mail",
    "user.label.email.placeholder": "E-Mail",
    "user.label.email.error": "E-Mail ist erforderlich",
    "user.label.email.invalid": "Ungültiges E-Mail-Format",
    "user.label.firstName": "Vorname",
    "user.label.firstName.placeholder": "Vorname",
    "user.label.firstName.error": "Vorname ist erforderlich",
    "user.label.lastName": "Nachname",
    "user.label.lastName.placeholder": "Nachname",
    "user.label.lastName.error": "Nachname ist erforderlich",
    "user.label.organization": "Organisation",
    "user.label.homeStore": "Hauptgeschäft",
    "user.label.homeStore.placeholder": "Hauptgeschäfte suchen",
    "user.label.homeStore.noFound": "Keine Hauptgeschäfte gefunden",
    "user.label.allowedStores": "Zugelassene Geschäfte",
    "user.select.store.placeholder": "Geschäfte suchen",
    "user.select.store.noFound": "Keine Geschäfte gefunden",
    "user.label.roles": "Rollen",

    "rfid.label.tag": "RFID-Etikett",
    "rfid.label.allZones": "Alle Zonen",
    "rfid.label.serial": "Seriennummer",
    "rfid.label.epc": "EPC",
    "rfid.label.zone": "Zone",
    "rfid.label.date": "Datum",
    "rfid.label.nonLocalized": "Nicht lokalisiert",

    "signOut.success": "Ihre Sitzung ist beendet. Bitte melden Sie sich an, um auf Ihr Konto zuzugreifen.",
    "signOut.error": "Beim Abmelden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
}
